export enum ShopTypesEnum {
    clinic="clinic",
    entOffice="entOffice"
}
